import { spToolsAccredibleDuplicateManagementLocs } from './components/accredible-duplicate-management/accredible-duplicate-management.locs';
import { spToolsAccredibleManagementLocs } from './components/accredible-management/accredible-management.locs';
import { spToolsAccredibleBadgeSearchLocs } from './components/badge-search/badge-search.locs';
import { spToolsAccredibleDataLocs } from './components/candidate-accredible-data/candidate-accredible-data.locs';
import { spToolsAccredibleSearchFormLocs } from './components/search-form/accredible-search-form.locs';

export const accredibleModuleLocs = {
	...spToolsAccredibleDuplicateManagementLocs,
	...spToolsAccredibleSearchFormLocs,
	...spToolsAccredibleManagementLocs,
	...spToolsAccredibleBadgeSearchLocs,
	...spToolsAccredibleDataLocs,
};
